export const LAUNCH_VOID_MODAL = 'LAUNCH_VOID_MODAL';
export const launchVoidModal = ({ fulfillments, isLoading, shouldReconcileShipTo }) => ({
  type: LAUNCH_VOID_MODAL,
  fulfillments,
  isLoading,
  shouldReconcileShipTo,
});

export const ON_VOID_MODAL_CLOSED = 'ON_VOID_MODAL_CLOSED';
export const onVoidModalClosed = ({ isCancel }) => ({
  type: ON_VOID_MODAL_CLOSED,
  isCancel,
});

export const ACCEPT_WARNING_AND_VOID = 'ACCEPT_WARNING_AND_VOID';
export const acceptWarningAndVoid = (shouldReconcileShipTo) => ({
  type: ACCEPT_WARNING_AND_VOID,
  shouldReconcileShipTo,
});

export const VOID_LABELS = 'VOID_LABELS';
export const voidLabels = (fulfillmentIds, shouldReconcileShipTo) => ({
  type: VOID_LABELS,
  fulfillmentIds,
  shouldReconcileShipTo,
});

export const VOID_LABELS_SUCCESS = 'VOID_LABELS_SUCCESS';
export const voidLabelsSuccess = (updatedFulfillments) => ({
  type: VOID_LABELS_SUCCESS,
  updatedFulfillments,
});

export const VOID_LABELS_FAILURE = 'VOID_LABELS_FAILURE';
export const voidLabelsFailure = () => ({
  type: VOID_LABELS_FAILURE,
});

export const RETRY_VOID = 'RETRY_VOID';
export const retryVoid = (shouldReconcileShipTo) => ({
  type: RETRY_VOID,
  shouldReconcileShipTo,
});

export const LOAD_BULK_VOID_RESPONSE = 'LOAD_BULK_VOID_RESPONSE';
export const loadBulkVoidResponse = (voidWarnings, successfullyVoided) => ({
  type: LOAD_BULK_VOID_RESPONSE,
  voidWarnings,
  successfullyVoided,
});
